import { ICommentCommonListQueryParams, ICommentCommonPostBody, ICommentResponse } from '@sparelabs/comment-client'
import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  ICaseObjectLinkPostBody,
  ICaseObjectLinkResponse,
  ICasePatchBody,
  ICasePostBody,
  ICaseResponse,
  ICaseSearchQueryParams,
  ICaseSearchResponse,
  ICaseSummaryRefreshPostBody,
  ICaseSummaryResponse,
  IListCaseQueryParams,
} from '../types'
import { Resources } from './ResourcesType'

export class CaseResource extends GenericResource<ICaseResponse, IListCaseQueryParams, ICasePatchBody, ICasePostBody> {
  public get = this.buildGet()
  public list = this.buildList()
  public post = this.buildPost()
  public patch = this.buildPatch()
  public del = this.buildDel()

  constructor(agent: IHttpAgent) {
    super(Resources.Cases, agent)
  }

  public async import(caseTypeId: string, file: File): Promise<void> {
    const formData = new FormData()
    formData.append('file', file)
    await this.agent.post(`${Resources.CaseTypes}/${caseTypeId}/import`, formData)
  }

  public async search(params: ICaseSearchQueryParams): Promise<ICaseSearchResponse> {
    const res = await this.agent.get<ICaseSearchResponse>(`${Resources.Cases}/search`, { params })
    return res.data
  }

  public async postCaseComment(caseId: string, body: ICommentCommonPostBody): Promise<ICommentResponse> {
    const res = await this.agent.post<ICommentResponse>(`${Resources.Cases}/${caseId}/comments`, body)
    return res.data
  }

  public async listCaseComments(
    caseId: string,
    params: ICommentCommonListQueryParams,
  ): Promise<{ data: ICommentResponse[] }> {
    const res = await this.agent.get<{ data: ICommentResponse[] }>(`${Resources.Cases}/${caseId}/comments`, { params })
    return res.data
  }

  public async getSummary(caseId: string): Promise<ICaseSummaryResponse> {
    const res = await this.agent.get<ICaseSummaryResponse>(`${Resources.Cases}/${caseId}/summary`)
    return res.data
  }

  public async refreshSummary(caseId: string, body: ICaseSummaryRefreshPostBody): Promise<ICaseSummaryResponse> {
    const res = await this.agent.post<ICaseSummaryResponse>(`${Resources.Cases}/${caseId}/summary/refresh`, body)
    return res.data
  }

  public async listObjectLinks(caseId: string): Promise<{ data: ICaseObjectLinkResponse[] }> {
    const res = await this.agent.get<{ data: ICaseObjectLinkResponse[] }>(`${Resources.Cases}/${caseId}/links`)
    return res.data
  }

  public async createObjectLink(caseId: string, body: ICaseObjectLinkPostBody): Promise<ICaseObjectLinkResponse> {
    const res = await this.agent.post<ICaseObjectLinkResponse>(`${Resources.Cases}/${caseId}/links`, body)
    return res.data
  }

  public async deleteObjectLink(caseId: string, linkId: string): Promise<void> {
    await this.agent.delete(`${Resources.Cases}/${caseId}/links/${linkId}`)
  }
}
